var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generic-toggle-component",class:_vm.className},[_c('input',{attrs:{"type":"hidden","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.toggled ? 1 : 0}}),_vm._v(" "),_c('div',{staticClass:"toggle",on:{"click":_vm.toggle}})])
}
var staticRenderFns = []

export { render, staticRenderFns }